import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface Props {
  handleBack: () => void;
  handleSkip?: () => void;
  handleNext: (method?: TemplateMethod | null) => void;
}

enum TemplateMethod {
  from_scratch = "from_scratch",
  use_bento_ai = "use_bento_ai",
}

const CreateTemplateForm = ({ handleBack, handleSkip, handleNext }: Props) => {
  const [method, setMethod] = useState<TemplateMethod | null>(null);

  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center" }}>
        <Box
          component="i"
          color="secondary.dark"
          sx={{ pr: 2 }}
          className="fa-solid fa-marker"
        />
        Your First Pitch Template
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ textAlign: "center", mb: 3 }}
      >
        An outreach template helps you reach out to brands by giving you a
        ready-made message. Do you have a template?
      </Typography>

      <Grid container justifyContent="center">
        <FormControl>
          <RadioGroup
            value={method}
            onChange={(e) => setMethod(e.target.value as TemplateMethod)}
          >
            <FormControlLabel
              value={TemplateMethod.from_scratch}
              control={<Radio />}
              label="Yes, I have one I'd like to use"
            />
            <FormControlLabel
              value={TemplateMethod.use_bento_ai}
              control={<Radio />}
              label={"No, use Bento AI to create one 🚀"}
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs="auto" container columnGap={1}>
        <Grid item xs="auto">
          <Button onClick={handleBack} color="secondary" disableElevation>
            Back
          </Button>
        </Grid>
        <Grid item xs></Grid>

        {handleSkip && (
          <Grid item xs="auto">
            <Button onClick={handleSkip} disableElevation color="secondary">
              Skip
            </Button>
          </Grid>
        )}
        <Grid item xs="auto">
          <LoadingButton
            disableElevation
            variant="contained"
            type="submit"
            disabled={!method}
            onClick={() => handleNext(method)}
          >
            Next
          </LoadingButton>
        </Grid>
      </Grid>
    </>
  );
};

export default CreateTemplateForm;
